gsap.registerPlugin(ScrollTrigger);
window.requestAnimationFrame(function() {
  ScrollTrigger.matchMedia({
    "(min-width: 768px)": function() {
        ScrollTrigger.create({
          trigger: ".co-plp-hero-left",
          pin: ".co-plp-hero-left-float",
          start: "top top",
          end: "bottom bottom"
        });
      }
  });
});
gsap.set(".co-plp-hero .co-ani-o", { opacity: 0 });
gsap.to(".co-plp-hero .co-ani-o", { 
  opacity: 1, 
  duration: 1,
  stagger: 0.15,
  ease: "Power1.inOut"
});